import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fb-marketplace-tax';

export default function Example() {
  return (
    <>
      <Head>
        <title>Sellers Guide 101:Facebook Marketplace Tax Identification</title>
        <meta
          name='description'
          content='Stay tax-compliant and get yourself familiarized with your tax responsibilities as a Facebook Marketplace seller.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fb-marketplace-tax' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fb-marketplace-tax' />
        <meta property='og:title' content='Sellers Guide 101:Facebook Marketplace Tax Identification' />
        <meta
          property='og:description'
          content='Stay tax-compliant and get yourself familiarized with your tax responsibilities as a Facebook Marketplace seller.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 22nd, 2022' />
        <meta property='article:modified_time' content='April 22nd, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
